export const locale = {
  lang: 'vn',
  data: {
    'SALE': {
      'DATA_MANAGEMENT': 'Cơ sở dữ liệu',
      'PAYMENT_HISTORY': 'Dữ liệu thanh toán',
      'MASTER_LIST': 'Dữ liệu tổng hợp',
      'DATA_RECONCILIATION': 'Dữ liệu cần xử lý',
      'TO_BE_RECONCILE_DATA': 'Cần đối soát',
      'TRANSACTION_NOT_FOUND': 'Không có thanh toán',
      'ORDER_NOT_FOUND': 'Không có đơn hàng',
      'SYNCHRONIZATION_LOG': 'Lịch sử đồng bộ'
    },
    'SERVER_ERROR': 'Hệ thống lỗi, vui lòng liên hệ bộ phận hỗ trợ để được giúp đỡ',
  }
};
